import { AxiosError } from "axios";
import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";

import { fetchVideoSermons } from "../lib/api";

const _fetchVideoSermons = async () => await fetchVideoSermons();

export default function useVideoSermons<TData = Videos>(
  options?: UseQueryOptions<Videos, AxiosError, TData>
): UseQueryResult<TData, AxiosError> {
  return useQuery("video-sermons", _fetchVideoSermons, options);
}
